import moment from 'moment';
import { has, uniq } from 'lodash';

export function dateFormat(str, format = 'YYYY-MM-DD HH:mm:ss') {
  if (!str || str === '') {
    return '';
  }

  const date = moment(new Date(str));
  if (!date.isValid()) {
    return '';
  }
  return moment(new Date(date.toLocaleString())).format(format);
}

export const JSON_CONTENT_TYPE = 'application/json';
export const DEFAULT_X_API_KEY = 'da2-begruz5xtfhzdmzld5wypqv4ne';

export function getValuesDeepByKey(obj, key, setObj) {
  const result = [];
  if (has(obj, key)) {
    result.push(setObj ? setObj(obj, key) : obj[key]);
  }

  let child = [];
  for (const prop in obj) {
    if (typeof obj[prop] === 'object') {
      child = [
        ...child,
        ...getValuesDeepByKey(obj[prop], key, setObj),
      ];
    }
  }

  return uniq([...result, ...child]);
}

export function escapeForRegex(string) {
  return string.replace(/[.*+?^${}()|[\]\\/]/g, '\\$&');
}

export function getUiOptions(uiSchema) {
  // get all passed options from ui:widget, ui:options, and ui:<optionName>
  return Object.keys(uiSchema)
    .filter((key) => key.indexOf('ui:') === 0)
    .reduce((options, key) => {
      const value = uiSchema[key];

      if (key === 'ui:widget' && isObject(value)) {
        console.warn(
          'Setting options via ui:widget object is deprecated, use ui:options instead',
        );
        return {
          ...options,
          ...(value.options || {}),
          widget: value.component,
        };
      }
      if (key === 'ui:options' && isObject(value)) {
        return { ...options, ...value };
      }
      return { ...options, [key.substring(3)]: value };
    }, {});
}

export function isObject(thing) {
  if (typeof File !== 'undefined' && thing instanceof File) {
    return false;
  }
  return typeof thing === 'object' && thing !== null && !Array.isArray(thing);
}
